export const SET_COMUNICADOS = 'SET_COMUNICADOS';
export const SET_COMUNICADO = 'SET_COMUNICADO';
export const SET_COMUNICADO_ADJUNTOS = 'SET_COMUNICADO_ADJUNTOS';
export const SET_COMUNICADOS_STATUS = 'SET_COMUNICADOS_STATUS';
